import { render, staticRenderFns } from "./BackToDashboard.vue?vue&type=template&id=66ff0796&"
import script from "./BackToDashboard.vue?vue&type=script&lang=js&"
export * from "./BackToDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports